module.exports = __webpack_public_path__ + "static/media/hinfact_logo.c11e5794.png";